import React from "react";
import I18n from 'i18n.js.erb'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { displayTranslations, getArtwork, parseBlueprintImageNameAndEdition, parseCategoryName } from "../../utils/utils";
import PlaceholderImage from "./PlaceholderImage";
import TextOverlayOnImage from "./TextOverlayOnImage";


const SealedProductTableItem = ({blueprintImages, era_index, era_name, handleNavigation, onKeyDownQuantity, onChangeQuantity, onCheckHandler }) => {

  return(
      <table id="order-edit"
             className="table table-hover mt-10px bg-white">
        <thead className="thead-dark">
        <tr>
          <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderImage')}</th>
          <th className="text-center minW-150px">{I18n.t('js.indexSealedPage.releaseData')}</th>
          <th className="text-center">{I18n.t('js.indexSealedPage.category')}</th>
          <th className="text-center">{I18n.t('js.indexSealedPage.name')}</th>
          <th className="text-center" />
          <th className="text-center">{I18n.t('js.indexSealedPage.artwork')}</th>
          <th className="text-center">{I18n.t('js.indexSealedPage.language')}</th>
          <th className="text-center">{I18n.t('js.indexSealedPage.quantity')}</th>
          <th className="text-center">{I18n.t('js.indexSealedPage.info')}</th>
          <th className="text-center"/>
          <th className="text-center">{I18n.t('js.indexSealedPage.choose')}</th>
        </tr>
        </thead>
        <tbody>
        {
          blueprintImages.map((blueprintImage, blueprint_image_index) => {
            const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

            return (<tr key={blueprint_image_index}
                id={blueprintImage.id}
                className={`${blueprintImage.checked === true && 'sealed-table-selected-row'} ${blueprintImage.encasing_id && 'cursor-pointer'}`}
                onClick={(e) => onCheckHandler(e, blueprintImage.id)}>
              <td className="text-center p-0">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`blueprintImage-tooltipInfo`} className="minW-250px" >
                      <div className="d-flex justify-content-center position-relative text-center w-100 h-100">
                        {
                          blueprintImage.medium_image_url ?
                            <React.Fragment>
                              <img
                                className="image-card-list-tooltip  rounded mt-4 mb-4"
                                style={{borderRadius: "7px"}}
                                src={blueprintImage.medium_image_url}
                                alt=""
                              />

                              {
                                !blueprintImage.encasing_id &&
                                  <TextOverlayOnImage
                                    textOverlay={I18n.t('js.common.notGradableProduct')}
                                    size={'thumb'}
                                    type={'red-overlay'}
                                  />
                              }
                            </React.Fragment>
                          :
                            <PlaceholderImage
                              size={'medium'}
                              overlaySize={'thumb'}
                              additionalClasses="image-card-list-tooltip  rounded mt-4 mb-4"
                              textOverlay={getArtwork(blueprintImage)}
                              showNotGradableProductOverlay={!blueprintImage.encasing_id}
                            />
                        }
                      </div>
                    </Tooltip>
                  }
                >
                  <i className="fas fa-images fa-lg"></i>
                </OverlayTrigger>
              </td>
              <td className="minW-150px text-center">{blueprintImage.released_at}</td>
              <td className="text-center">
                { parseCategoryName(blueprintImage.category_name) }
              </td>
              <td className="minW-150px">
                {
                  blueprintImageNames.length > 1 ? (
                    <div className="text-dark noselect">
                      <p className="mb-0">
                        {
                          parseBlueprintImageNameAndEdition(blueprintImage.game_name, blueprintImage.edition, blueprintImageNames[0])
                        }
                      </p>
                      <p className="d-none d-md-block mb-0">
                        {
                          blueprintImageNames[1]
                        }
                      </p>
                    </div>
              ) : (
                <div className="text-dark noselect d-none d-md-block">
                  <p className="mr-3 mb-0">
                    {
                      parseBlueprintImageNameAndEdition(blueprintImage.game_name, blueprintImage.edition, blueprintImageNames[0])
                    }
                  </p>
                </div>
              )}</td>

              <td className="text-center">
                {
                  blueprintImage.expansion_icon_url &&
                    <img src={blueprintImage.expansion_icon_url}
                         style={{ height: "30px", minHeight: "20px" }} alt=""/>
                }
              </td>

              <td className="text-center">
                <p className="mr-3 mb-0">
                  {
                    blueprintImage.artworks ? blueprintImage.artworks.artwork_eng : ''
                  }
                </p>
              </td>

              <td className="text-center">
                <p>
                  <img
                    src={window.location.origin + `/images/flags/${blueprintImage.language}.png`}
                    style={{maxHeight: "20px"}} alt=""/>
                </p>
              </td>
              <td className=" text-center">
                <div className="card-number noselect quantity-content p-2">
                  <div className="noselect">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                        </Tooltip>
                      }
                    >
                      <div>
                        <input
                          className="form-control w-50 m-auto minW-70px"
                          value={blueprintImage.quantity ? blueprintImage.quantity : ''}
                          name="bluprint_image_quantity"
                          type="number"
                          disabled={!blueprintImage.checked}
                          onKeyDown={(e) => onKeyDownQuantity(e)}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => onChangeQuantity(e, era_index, era_name, blueprint_image_index)}
                          data-id={blueprintImage.id}
                        />
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </td>
              <td>
                <button
                  id={"product_info_" + blueprintImage.id}
                  className="btn btn-dark text-light btn-sm rounded noselect align-self-center w-100"
                  onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}>
                  {I18n.t('js.indexSealedPage.productInfo')}
                </button>
              </td>
              <td>
                { blueprintImage.already_in_wishlist > 0 &&
                <p className="w-100 mt-10px mb-0 text-center">
                  {I18n.t('js.common.thisCardIn')} &nbsp;
                  <span className="data-structure-link"
                        style={{cursor: 'pointer', color: "inherit"}}
                        onClick={(e) => handleNavigation(e, null, `/wishlists/${blueprintImage.already_in_wishlist}/edit`)}>
                        {I18n.t('js.common.yourWishlist')}
                  </span>
                </p>
                }
              </td>
              <td>
                {
                  blueprintImage.encasing_id &&
                    <input type="checkbox"
                           checked={blueprintImage.checked === true}
                           id={"checkbox_" + blueprintImage.id}
                           onChange={(e) => onCheckHandler(e, blueprintImage.id)}
                           className="checkbox sealed-table-checkbox"
                    />
                }
              </td>
            </tr>)
          })
        }
        </tbody>
      </table>
    )
}

export default SealedProductTableItem;